export async function initStageReport({ token, userId, email, name, userType, reportId, themeName }) {
  const tokenStr = String(token ?? '').trim();
  const [sessionIdFromToken, organizationIdFromToken] = tokenStr.includes('&')
    ? tokenStr.split('&')
    : [null, null];
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/initStageReport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      email,
      name,
      user_type: userType,
      reportid: reportId,
      themeName,
      ...(sessionIdFromToken ? { sessionId: String(sessionIdFromToken) } : {}),
      ...(organizationIdFromToken ? { organizationId: String(organizationIdFromToken) } : {}),
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to initialize stage report');
  }
  return data;
}

export async function updateStageProgress({
  token,
  userId,
  dayNumber,
  points,
  timeSeconds,
  answer,
  allCorrect,
  email,
  name,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStageProgress`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      dayNumber,
      points,
      timeSeconds,
      answer,
      allCorrect,
      email,
      name,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to update stage progress');
  }
  return data;
}

export async function updateStageFeedback({ token, userId, dayNumber, feedback, stageId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/updateStageFeedback`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      dayNumber,
      feedback,
      stageId,
    }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok || !data.success) {
    throw new Error(data.message || 'Failed to update stage feedback');
  }
  return data;
}
